import { getNextWeekDates } from "b2b/utils/date";

import { ZADOSTI } from "b2b/constants";

export default function getNejblizsiRezervaceProps() {
  return {
    ...getNextWeekDates(),
    stav: ZADOSTI.STAV.POTVRZENY
  };
}
